const InvoiceIcon = () => {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.9375 11.5288H14.0625M5.9375 9.02881H14.0625M2.5 17.1538V5.27881C2.5 5.11305 2.56585 4.95408 2.68306 4.83687C2.80027 4.71966 2.95924 4.65381 3.125 4.65381H16.875C17.0408 4.65381 17.1997 4.71966 17.3169 4.83687C17.4342 4.95408 17.5 5.11305 17.5 5.27881V17.1538L15 15.9038L12.5 17.1538L10 15.9038L7.5 17.1538L5 15.9038L2.5 17.1538Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InvoiceIcon;
